import { validate } from 'email-validator';
import { TelecomType } from '../types';

export function validateEmail(
  email: string,
  { allowBlank }: { allowBlank: boolean } = { allowBlank: false },
): boolean {
  return validate(email) || (email.length === 0 && allowBlank);
}

export function validateEmailWithoutLifenMss(
  email: string,
  { allowBlank }: { allowBlank: boolean } = { allowBlank: false },
): boolean {
  return (validate(email) && !isLifenMssEmail(email)) || (email.length === 0 && allowBlank);
}

export function isLifenMssEmail(email: string): boolean {
  return email.endsWith('lifen.mssante.fr');
}

export function isApiCryptOrMssEmail(email: string): boolean {
  return isApiCryptEmail(email) || isMssEmail(email);
}

export function isApiCryptEmail(email: string): boolean {
  return getEmailType(email) === TelecomType.APICRYPT;
}

export function isMssEmail(email: string): boolean {
  return getEmailType(email) === TelecomType.MSSANTE;
}

export function isGenericEmail(email: string): boolean {
  return getEmailType(email) === TelecomType.EMAIL;
}

export function getEmailType(
  email: string,
): TelecomType.MSSANTE | TelecomType.APICRYPT | TelecomType.EMAIL | undefined {
  const domain = extractDomain(email);

  if (!domain) {
    return undefined;
  }

  return validateDomainType(domain);
}

export function getCustomEmailType(email: string): TelecomType | undefined {
  const domain = extractDomain(email);

  if (!domain) {
    return undefined;
  }

  return validateCustomDomainType(domain);
}

function extractDomain(email: string): string | undefined {
  const domain = email.split('@')[1];

  if (!domain || domain.length < 1) {
    return undefined;
  }

  return domain;
}

function validateDomainType(
  domain: string,
): TelecomType.MSSANTE | TelecomType.APICRYPT | TelecomType.EMAIL | undefined {
  if (domain.endsWith('mssante.fr') || domain.endsWith('interop-mssante.apicrypt.org')) {
    return TelecomType.MSSANTE;
  }

  if (domain.endsWith('apicrypt.org') || domain.endsWith('apicrypt.fr')) {
    return TelecomType.APICRYPT;
  }

  return TelecomType.EMAIL;
}

function validateCustomDomainType(domain: string): TelecomType | undefined {
  if (domain.endsWith('.mssante.fr') && domain !== 'mssante.fr') {
    return TelecomType.MSSANTE;
  }

  if (domain === 'medical.apicrypt.org' || /^medical[a-zA-Z0-9-]*\.apicrypt\.org$/.test(domain)) {
    return TelecomType.APICRYPT;
  }

  return TelecomType.EMAIL;
}

export function isLifenInternalEmail(email: string): boolean {
  return !!/@(test\.)?lifen\.fr$/i.exec(email);
}
